export const UNIT_OF_MEASURE_DOCUMENT_DROP_DOWN_ITEMS = []